export const subtract = (firstArray, ...otherArrays) => firstArray.filter(element => !otherArrays.find(arr => arr.includes(element)));
export const compact = array => array.filter(Boolean);
export const isPresent = array => Array.isArray(array) && array.length > 0;
export const isEmpty = array => !isPresent(array);
export const groupBy = (items, key) => items.reduce(
  (result, item) => ({
    ...result,
    [item[key]]: [
      ...(result[item[key]] || []),
      item,
    ],
  }),
  {},
);
export const uniq = array => [...new Set(array).values()];
export const remove = (array, value) => array.filter(item => item !== value);
export const insertBetween = (array, element) => {
  return array.flatMap((item, index) => {
      return index === array.length - 1 ? [item] : [item, element];
  });
};

export const sliceAt = ((array, position) => {
  return [
    array.slice(0, position),
    array.slice(position, array.length)
  ];
});

export const findObjectByKeyValue = (array, key, value) => {
  return array.find((object) => object[key] === value);
};
export const findObjectIndexByKeyValue = (array, key, value) => {
  return array.findIndex((object) => object[key] === value);
};
